import React, { useEffect } from "react";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import { LuCopy } from "react-icons/lu";
const AssetCard = ({ asset, assetIndex, onEdit, onCopy, onDelete }) => {
  return (
    <div className="card rounded-3">
      <div className="card-body d-flex justify-content-between align-items-start p-2">
        <div>
          <h6 className="mb-1 text-break">{asset.assetName || "N/A"}</h6>
          <p className="text-dark fw-medium" style={{ fontSize: "0.8rem" }}>
            Cost: {asset.purchaseCost || "-"} <br />
            Manufacturer: {asset.manufacturer || "-"}
          </p>
        </div>
        <div className="align-self-start">
          <span
            className="p-1 btn btn-outline-light ms-1"
            onClick={() => onCopy(assetIndex)}
          >
            <LuCopy className="text-dark" />
          </span>
          <span
            className="p-1 btn btn-outline-light ms-1"
            onClick={() => onEdit(assetIndex)}
          >
            <FiEdit2 className="text-dark" />
          </span>
          <span
            className="p-1 btn btn-outline-light ms-1"
            onClick={() => onDelete(assetIndex)}
          >
            <FiTrash2 className="text-dark" />
          </span>
        </div>
      </div>
    </div>
  );
};

export default AssetCard;
